import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NavbarComponent } from "./navbar/navbar.component";
import { BadgeComponent } from './badge/badge.component';

@NgModule({
  declarations: [NavbarComponent, BadgeComponent],
  imports: [CommonModule],
  exports: [NavbarComponent, BadgeComponent]
})
export class BasicModule {}
